/**
 * @return {boolean}
 */
export default function EmailCheck(str) {
  const re = /\S+@\S+\.\S+/;
  return re.test(str);
}
